(() => {
  'use strict';

  class ZymaPdBar extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const scope = this.closest('[data-zyma-pd]');
      const target = scope?.querySelector('[data-zyma-pd-buy]');
      if (!scope || !target || !('IntersectionObserver' in window)) return;

      this.controller = new AbortController();
      const { signal } = this.controller;
      const button = this.querySelector('[data-zyma-pd-bar-submit]');

      button?.addEventListener('click', () => {
        const submit = scope.querySelector('[data-zyma-pd-buy] [ref="addToCartButton"]');
        if (!(submit instanceof HTMLButtonElement) || submit.disabled) return;
        // Use the primary button path so Bundler receives its click before submission.
        submit.click();
      }, { signal });

      scope.addEventListener('zyma:purchase-change', (event) => {
        if (button instanceof HTMLButtonElement) button.disabled = event.detail?.available === false;
        const detail=event.detail||{};
        const text=this.querySelector('[data-zyma-pd-selection-label]');
        if(text instanceof HTMLElement && detail.label)text.textContent=detail.label;
      }, { signal });

      // The room the bar needs is reserved once, while the page has a bar at all. It must not follow the bar's
      // visibility: sections size themselves against it, and they would resize on every scroll past the buy options.
      this.reserveSpace();
      addEventListener('resize', this.reserveSpace, { signal, passive: true });

      this.observer = new IntersectionObserver(([entry]) => {
        // Only after the buy options have scrolled up and out of view, not before reaching them.
        this.setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      this.observer.observe(target);
    }

    reserveSpace = () => {
      const height = Math.ceil(this.getBoundingClientRect().height);
      if (height > 0) document.body.style.setProperty('--zyma-pd-bar-space', `${height}px`);
    };

    setVisible(visible) {
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      this.querySelectorAll('button').forEach((button) => { button.tabIndex = visible ? 0 : -1; });
      document.body.classList.toggle('zyma-pd-bar-visible', visible);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      document.body.classList.remove('zyma-pd-bar-visible');
      document.body.style.removeProperty('--zyma-pd-bar-space');
    }
  }

  if (!customElements.get('zyma-pd-bar')) customElements.define('zyma-pd-bar', ZymaPdBar);

  if (window.zymaPdWired) return;
  window.zymaPdWired = true;

  // Theme editor: selecting a collapsible row opens it.
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target instanceof HTMLDetailsElement && event.target.classList.contains('zyma-pd-accordion')) event.target.open = true;
  });
})();

